import { render } from "./DeleteAccountPage.vue?vue&type=template&id=0094d139&scoped=true"
import script from "./DeleteAccountPage.vue?vue&type=script&lang=js"
export * from "./DeleteAccountPage.vue?vue&type=script&lang=js"

import "./DeleteAccountPage.vue?vue&type=style&index=0&id=0094d139&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0094d139"]])

export default __exports__